import { useMutation, useQueryClient } from '@tanstack/react-query';

import { coursesApi } from '../api';
import { COURSE_TRAINER_INVITATIONS_QUERY_KEY } from '../queries/course-trainer-invitations-query';

type CancelCourseTrainerInvitationRequest = {
  courseId: string;
  invitationId: string;
};

export const useCancelCourseTrainerInvitationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: CancelCourseTrainerInvitationRequest) => {
      await coursesApi.cancelCourseTrainerInvitation({
        courseId: request.courseId,
        invitationId: request.invitationId
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [COURSE_TRAINER_INVITATIONS_QUERY_KEY, variables.courseId]
      });
    }
  });
};
